"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsInsurance = void 0;
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
require("./app-settings-insurance.less");
const copay_blacklist_1 = require("./component/copay-blacklist/copay-blacklist");
const ndc_blacklist_1 = require("./component/ndc-blacklist");
const dummyBlacklist = {
    bin: "",
    id: null,
    name: "",
    pcn: ""
};
// TMPP > Pharmacies >  Settings - NDC Blacklist E-059 full chnage the compoents 
let AppSettingsInsurance = class AppSettingsInsurance extends React.Component {
    constructor(props) {
        super(props);
        this.copayComponentRef = null;
        this.ndcComponentRef = null;
        this.isLoadingCopay = false;
        this.isLoadingNDC = false;
        this.handleNdc = () => {
            if (!this.ndcComponentRef) {
                this.isLoadingNDC = true;
                this.copayComponentRef = null;
                Promise.resolve().then(() => require("./component/ndc-blacklist")).then((module) => {
                    this.ndcComponentRef = React.createElement(ndc_blacklist_1.AppSettingsNdcBlacklist, null);
                    this.isLoadingNDC = false;
                });
            }
        };
        this.handleCopay = () => {
            if (!this.copayComponentRef) {
                this.isLoadingCopay = true;
                this.ndcComponentRef = null;
                Promise.resolve().then(() => require("./component/copay-blacklist/copay-blacklist")).then((module) => {
                    this.copayComponentRef = React.createElement(copay_blacklist_1.AppSettingsCopay, null);
                    this.isLoadingCopay = false;
                });
            }
        };
        this.isLoadingCopay = true;
        Promise.resolve().then(() => require("./component/copay-blacklist/copay-blacklist")).then((module) => {
            this.copayComponentRef = React.createElement(copay_blacklist_1.AppSettingsCopay, null);
            this.isLoadingCopay = false;
        });
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "insurancesettings-tabs insurancesettings-container" },
                React.createElement("button", { className: ` ${this.isLoadingNDC || !this.ndcComponentRef ? "tabactive" : ""}`, 
                    // style={{            
                    //   backgroundColor:
                    //     this.isLoadingCopay || !this.ndcComponentRef
                    //       ? "#192e5b"
                    //       : "",
                    // }}
                    onClick: this.handleCopay }, "Copay Blacklist"),
                React.createElement("button", { className: ` ${this.isLoadingNDC || !this.ndcComponentRef ? "" : "tabactive"}`, 
                    // style={{
                    //   backgroundColor:
                    //     this.isLoadingNDC || !this.ndcComponentRef
                    //       ? ""
                    //       : "#192e5b",
                    // }}
                    onClick: this.handleNdc }, "NDC Blacklist")),
            this.isLoadingCopay ? (React.createElement("div", null, "Loading Copay...")) : this.copayComponentRef ? (React.createElement(React.Suspense, { fallback: React.createElement("div", null, "Loading...") }, this.copayComponentRef)) : null,
            this.isLoadingNDC ? (React.createElement("div", null, "Loading NDC...")) : this.ndcComponentRef ? (React.createElement(React.Suspense, { fallback: React.createElement("div", null, "Loading...") }, this.ndcComponentRef)) : null));
    }
};
__decorate([
    mobx_1.observable.ref
], AppSettingsInsurance.prototype, "copayComponentRef", void 0);
__decorate([
    mobx_1.observable.ref
], AppSettingsInsurance.prototype, "ndcComponentRef", void 0);
__decorate([
    mobx_1.observable
], AppSettingsInsurance.prototype, "isLoadingCopay", void 0);
__decorate([
    mobx_1.observable
], AppSettingsInsurance.prototype, "isLoadingNDC", void 0);
AppSettingsInsurance = __decorate([
    mobx_react_1.observer
], AppSettingsInsurance);
exports.AppSettingsInsurance = AppSettingsInsurance;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-insurance/app-settings-insurance.tsx
// module id = 3194
// module chunks = 0